import React from 'react';

const RequiredIndicator: React.FC = () => <span className="text-danger">*</span>;

export default RequiredIndicator;